import React from 'react';

import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { ColumnDefinition, HeadCellFilterType } from 'components/DataTable/DataTableTypes';
import i18next from 'i18next';
import { RevisionDetail } from 'views/RevisionHistory/RevisionDtos';
import { JBIcon } from '@bjb-gcrm/gcrm-frontend-components';
import { isStringNotBlank } from 'utils/utils';

export const revisionHistoryHeadcells = (
  onOpenError: (row: RevisionDetail) => void,
): ColumnDefinition<RevisionDetail>[] => {
  return [
    {
      id: 'section',
      label: i18next.t('revisionHistory.table.section', 'Section'),
      filter: HeadCellFilterType.SORT,
      render: function Render(row: RevisionDetail) {
        return (
          <Box display="flex">
            <Typography data-testid="history-table-section" marginRight={row.error ? '10px' : '0'}>
              {row.section}
            </Typography>
            {row.error ? (
              <Tooltip
                arrow
                onClose={function noRefCheck() {}}
                onOpen={function noRefCheck() {}}
                placement="bottom-start"
                title={i18next.t('revisionHistory.table.error.tooltip') as string}
              >
                <IconButton
                  sx={{ padding: '0' }}
                  data-testid="history-table-section-error-button"
                  onClick={() => onOpenError(row)}
                >
                  <JBIcon iconName="dangerSolid" fill="red" />
                </IconButton>
              </Tooltip>
            ) : null}
          </Box>
        );
      },
    },
    {
      id: 'fieldNameTranslation',
      label: i18next.t('revisionHistory.table.attribute'),
      filter: HeadCellFilterType.EMPTY,
      shouldFormatEnum: true,
      render: function Render(row) {
        return <Typography data-testid="history-table-attribute">{row.fieldNameTranslation}</Typography>;
      },
    },
    {
      id: 'oldValueTranslation' as any,
      label: i18next.t('revisionHistory.table.previousValue'),
      filter: HeadCellFilterType.EMPTY,
      shouldFormatEnum: true,
      render: function Render(row) {
        return (
          <Typography data-testid="history-table-old-value">
            {isStringNotBlank(row.oldValueTranslation) ? row.oldValueTranslation : row.oldValue}
          </Typography>
        );
      },
    },
    {
      id: 'newValueTranslation' as any,
      label: i18next.t('revisionHistory.table.newValue'),
      filter: HeadCellFilterType.EMPTY,
      shouldFormatEnum: true,
      render: function Render(row) {
        return (
          <Typography data-testid="history-table-new-value">
            {isStringNotBlank(row.newValueTranslation) ? row.newValueTranslation : row.newValue}
          </Typography>
        );
      },
    },
  ];
};
